import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Unica lectura y normalizacion del querystring del checkout.
 *
 * Las reglas de saneo viven SOLO aca: antes cada pantalla parseaba por su cuenta
 * y normalizaba distinto (BonusesInfoModal releia "t", "em" se leia crudo).
 *
 * - t, fi, token: lowercase (ids y fechas, case-insensitive).
 * - c, p: trim (los ids char de SIGUE traen padding).
 * - em, l: Base64 => NO lowercase, y se restauran los "+" que el querystring
 *   decodifica como espacios. Sin eso, un cifrado con "+" llega corrupto: el
 *   link roto no falla, simplemente pierde la atribucion (em) o el tipo de
 *   asistente (l) en silencio.
 */
export const parseCheckoutParams = (search) => {
  const params = new URLSearchParams(search);
  return {
    t: params.get('t')?.toLowerCase() || 'g',
    c: params.get('c')?.trim() || null,
    p: params.get('p')?.trim() || null,
    fi: params.get('fi')?.toLowerCase() || null,
    token: params.get('token')?.toLowerCase() || null,
    em: params.get('em')?.replace(/ /g, '+') || null,
    l: params.get('l')?.replace(/ /g, '+') || null,
  };
};

export const useCheckoutParams = () => {
  const { search } = useLocation();
  return useMemo(() => parseCheckoutParams(search), [search]);
};

export default useCheckoutParams;
